// extracted by mini-css-extract-plugin
export default {"content":"PopupVolunteers_content__jAgMT","content__header":"PopupVolunteers_content__header__8Lf7D","content__header__chesed":"PopupVolunteers_content__header__chesed__1gy7s"};